module.exports = __webpack_public_path__ + "img/welcome.64b6899d.png";